<header class="filters-header">
  <fieldset class="filters__search">
    <input
      class="cds-form-field filters__input"
      type="search"
      aria-label="Pesquise por nome do registro"
      placeholder="Pesquise por nome do registro"
      [value]="searchTerm()"
      (input)="onInput($event)"
      (keydown.enter)="onSubmit()"
    />

    @if (searchTerm() !== '' && isSubmitted()) {
      <button
        class="cds-button s-plain c-secondary filters__action"
        type="button"
        aria-label="Limpar busca"
        (click)="onClear()"
      >
        <i class="cds-icon-close" aria-hidden="true"></i>
      </button>
    } @else {
      <button
        class="cds-button s-solid c-primary filters__action"
        type="button"
        aria-label="Buscar"
        (click)="onSubmit()"
      >
        <i class="cds-icon-search" aria-hidden="true"></i>
      </button>
    }
  </fieldset>

  <section class="filters__applied">
    <bfm-active-filters
      [clearFiltersText]="'Limpar filtros'"
      (activeFiltersCount)="onFiltersCount($event)"
    />

    <button class="cds-button s-plain c-secondary filters__button" type="button" (click)="openFilters.emit()">
      <i class="cds-icon-filter" aria-hidden="true"></i>
      Filtros
    </button>

    @if (filtersCount() > 0) {
      <span class="filters__count" [attr.aria-label]="filtersCount() + ' filtros aplicados'">
        {{ filtersCount() }}
      </span>
    }
  </section>
</header>
